
export const keyPressHandler = (ev: React.KeyboardEvent<HTMLInputElement>, key: KeyboardEvent["key"], callback: Function) => {
    if(ev.key == key){
        callback()
    }
}